export default "__VITE_ASSET__91351664__"